import {makeMachine, makeOptions} from "@/store";

export default container => {
    container.declare("store", dependencies => {
        const {$store} = dependencies;
        return $store.useMachine(makeMachine(), makeOptions(dependencies));
    });
};
